import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import FirstBlock from "./MainPageComponents.js/FirstBlock";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../Images/CloseImg.png";
import FilterImage from "../Images/FilterImage.png";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

export default function SpecialOffers() {
  const { t, i18n } = useTranslation();
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  const [Choose, setChoose] = useState(0);

  const [isHovered, setIsHovered] = useState(null);

  const handleMouseEnter = (index) => {
    setIsHovered(index);
  };

  const handleMouseLeave = () => {
    setIsHovered(null);
  };

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${MyDomain}News/GetAllNews`);
        setData(response.data);
        console.log(response.data);
      } catch (err) {
        console.log(err.response.data);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  ////////////////////////////
  // Create dynamic refs
  const timerRefs = useRef([]);
  const displayRefs = useRef([]);

  // Function to format the time remaining
  const formatTime = (time) => {
    if (time <= 0) return "0 days 0:0:0";

    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / (1000 * 60)) % 60);
    const seconds = Math.floor((time / 1000) % 60);

    return `${days} ${t("profile.days")} ${t(
      "profile.and"
    )} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const timers = data?.map((cardData, index) => {
      const startDate = new Date();
      const endDate = new Date(cardData.dateEnd.split("-").reverse().join("-"));
      let remainingTime = endDate - startDate;

      if (!displayRefs.current[index]) {
        displayRefs.current[index] = React.createRef();
      }
      if (!timerRefs.current[index]) {
        timerRefs.current[index] = { current: null };
      }

      if (displayRefs.current[index].current) {
        displayRefs.current[index].current.innerText =
          formatTime(remainingTime);
      }

      timerRefs.current[index].current = setInterval(() => {
        remainingTime -= 1000;
        if (remainingTime <= 0) {
          clearInterval(timerRefs.current[index].current);
          remainingTime = 0;
        }
        if (displayRefs.current[index].current) {
          displayRefs.current[index].current.innerText =
            formatTime(remainingTime);
        }
      }, 1000);

      return timerRefs.current[index];
    });

    return () => {
      timers.forEach((timerRef) => clearInterval(timerRef.current));
    };
  }, [data]);
  const [ChooseFilter, setChooseFilter] = useState("All");
  const [openCart, setOpenCart] = useState(false);

  const [openDone, setOpenDone] = useState(false);

  const handleClose = () => {
    setOpenCart(false);
  };

  ///////////////////////
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  // const handleDivClick = (CategoryName, ProductId) => {
  //   history.push(`/news/${ProductId}`);
  // };

  const handleDivClick = (TheObject, NameOfCategory) => {
    history.push({
      pathname: `/news/${NameOfCategory}`,
      state: TheObject, // Pass CategoryName here
    });
  };

  const Filters = [
    { name: "All", label: t("profile.All") },
    { name: "Perfumes", label: t("categories.Perfumes") },
    { name: "Makeup", label: t("categories.Makeup") },
    { name: "Hair", label: t("categories.Hair") },
    { name: "Face", label: t("categories.Face") },
    { name: "BathandBody", label: t("categories.BathandBody") },
    { name: "ForMen", label: t("categories.ForMen") },
    { name: "Accessories", label: t("categories.Accessories") },
    { name: "HealthandCare", label: t("categories.HealthandCare") },
    { name: "Gifts", label: t("categories.Gifts") },
    { name: "Brands", label: t("categories.Brands") },
    // "Perfumes",
    // "Makeup",
    // "Hair",
    // "Face",
    // "Bath and Body",
    // "Men",
    // "Accessories",
    // "Health & Care",
    // "Gifts",
    // "Brands",
  ];

  // Helper function to parse DD-MM-YYYY into a Date object
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed
  };

  const WindowsForm = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            width: "20%",
          }}
        >
          <div
            style={{
              width: "100%",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            {Filters.map((item, index) => (
              <div
                key={item.id}
                style={{
                  marginBottom: 15,
                  width: "100%",
                  color:
                    isHovered === index
                      ? "#6d28d9"
                      : Choose === index
                      ? "#6d28d9"
                      : "black",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setChooseFilter(item.name);
                  setChoose(index);
                }}
                onMouseEnter={() => {
                  handleMouseEnter(index);
                }}
                onMouseLeave={() => {
                  handleMouseLeave(null);
                }}
              >
                <a style={{ fontSize: 18 }}>{item.label}</a>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  const MobileForm = () => {
    return (
      <>
        <Drawer
          open={openCart}
          onClose={handleClose}
          anchor="bottom"
          PaperProps={{
            style: {
              height: "auto", // Height adjusts to content
              //maxHeight: "90vh", // Optional: Limit max height
              overflow: "auto", // Enable scrolling
              //height: "100vh", // Set height to 100% of the viewport height
            },
          }}
        >
          <div
            style={{
              display: "flex",
              paddingBottom: 20,
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: "2%",
              paddingLeft: "2%",
              paddingTop: 15,
            }}
          >
            <a style={{ fontSize: 20, fontWeight: "500" }}>
              {t("profile.Filters")}
            </a>

            <img
              onClick={() => {
                handleClose();
              }}
              src={CloseImg}
              alt={"Expand"}
              style={{
                width: 25,
                height: 25,
                cursor: "pointer",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              paddingRight: "2%",
              paddingLeft: "2%",
            }}
          >
            <div
              style={{
                width: "100%",
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              {Filters.map((item, index) => (
                <div
                  key={item.id}
                  style={{
                    marginBottom: 15,
                    width: "100%",
                    color:
                      isHovered === index
                        ? "#6d28d9"
                        : Choose === index
                        ? "#6d28d9"
                        : "black",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setChooseFilter(item.name);
                    setChoose(index);
                    handleClose();
                  }}
                  onMouseEnter={() => {
                    handleMouseEnter(index);
                  }}
                  onMouseLeave={() => {
                    handleMouseLeave(null);
                  }}
                >
                  <a style={{ fontSize: 18 }}>{item.label}</a>
                </div>
              ))}
            </div>
          </div>
        </Drawer>
      </>
    );
  };

  return (
    <div
      style={{
        paddingTop: 50,
        paddingLeft: MyWidth <= 768 ? "2%" : "0%",
        paddingRight: MyWidth <= 768 ? "2%" : "0%",
        width: "100%",
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      <div
        style={{
          textAlign: "center",
          paddingBottom: 30,
        }}
      >
        <h1 style={{ fontWeight: 500, fontSize: 30 }}>
          {t("profile.Specialoffers")}
        </h1>
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          flexDirection: MyWidth <= 768 ? "column" : "row",
        }}
      >
        {MyWidth <= 768 ? (
          <button
            style={{
              width: "100%",
              height: 50,
              backgroundColor: "white",
              border: "1px solid black",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 50,
            }}
            onClick={() => {
              setOpenCart(true);
            }}
          >
            <img
              src={FilterImage} // Replace with your image URL
              alt="Placeholder"
              style={{
                width: 15,
                height: 15,
                objectFit: "cover",
                //borderRadius: "8px",
                cursor: "pointer",
              }}
            />
            &nbsp;<a>{t("profile.Specialoffersfilter")}</a>
          </button>
        ) : (
          <></>
        )}
        {MyWidth <= 768 ? <>{MobileForm()}</> : <>{WindowsForm()}</>}

        <div
          style={{
            display: "flex",
            width: MyWidth <= 768 ? "100%" : "80%",
            //backgroundColor: "blue",
            flexDirection: "column",
          }}
        >
          {Choose === 0 ? (
            <div style={{ width: "100%", paddingBottom: 50 }}>
              <FirstBlock />
            </div>
          ) : (
            <></>
          )}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                MyWidth <= 1024
                  ? "repeat(1, 1fr)"
                  : "repeat(2, minmax(200px, 1fr))", // Exactly 3 items per row
              //gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "20px",
              width: "100%",
            }}
          >
            {data.map((item, MyIndex) => {
              const endDate = parseDate(item.dateEnd);
              const isExpired = endDate < today; // Check if the end date is in the past
              // console.log(isExpired);
              // console.log(endDate);
              // console.log(today);

              return (
                <>
                  {isExpired ? (
                    <></>
                  ) : (
                    <>
                      {ChooseFilter === item.actionsFilter ||
                      ChooseFilter === "All" ? (
                        <>
                          <div
                            key={item.id}
                            style={{
                              backgroundColor: "#fff",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleDivClick(item, item.id);
                            }}
                          >
                            <div>
                              <img
                                src={item.image}
                                alt="Sample"
                                style={{
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                direction:
                                  i18n.resolvedLanguage === "en" ? "" : "rtl",
                                paddingTop: 15,
                              }}
                            >
                              <a
                                style={{
                                  fontSize: 14,
                                  color: "#6b21a8",
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <a> {t("profile.Specialofferwillendin")} </a>
                                <div>
                                  {data?.map((_, index) => (
                                    <div
                                      key={MyIndex}
                                      ref={(el) =>
                                        (displayRefs.current[MyIndex] = {
                                          current: el,
                                        })
                                      }
                                    >
                                      <></>
                                    </div>
                                  ))}
                                </div>
                              </a>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
